module.exports = __webpack_public_path__ + "img/multiplier_free_4.f019ee90.png";